import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/$project/trainingjobs/")({
  validateSearch: (s: Record<string, unknown>) => ({ q: typeof s.q === "string" ? s.q : undefined }),
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: "/$org/$project/environments", params, search: { tab: "runs", q: search.q }, replace: true });
  },
});
